export default {
  base: () => import("/home/homeyou/shc/build/build-headless/108006/layouts/base.vue").then(m => m.default || m),
  default: () => import("/home/homeyou/shc/build/build-headless/108006/layouts/default.vue").then(m => m.default || m)
}